import {pageInfo, initPage, exportData, upload,getCustomerPackerList,fileDownload,template} from './../api';
const diamondReportForm = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    addResp: null,
    editResp: null,
    initPageObj: null,
    initUpdateObj: null,
    deleteResp: null,
    regionCodeObj:null,
    exportObj: null,
    uploadResp: null,
    customerPackerResp: null,
    fileObj: null,
    templateObj:null,
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    //导出
    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    UPLOAD_DATA(state, data) {
      state.uploadResp = data
    },
    FILE_DATA(state, data) {
      state.fileObj = data;
    },
    CUSTOMER_PACKER_DATA(state, data) {
      state.customerPackerResp = data
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出数据
    async exportData({ commit }, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    // 导入数据
    async upload({ commit }, obj) {
      const resp = await upload(obj)
      commit('UPLOAD_DATA', resp)
    },
    //下拉框数据
    async getCustomerPackerList({ commit }, obj) {
      let resp = await getCustomerPackerList(obj);
      commit('CUSTOMER_PACKER_DATA', resp);
    },
    //附件下载
    async fileDownload({ commit }, obj) {
      let resp = await fileDownload(obj);
      commit('FILE_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
  }
}
export default diamondReportForm



// WEBPACK FOOTER //
// ./src/page/report/diamondReportForm/store/diamondReportForm.store.js